import { useRef } from "react";
import { useSchedulerStore } from "../state/scheduler.store";
import {
  loadAvailabilityForRoosterLink,
  loadAvailabilityForAutobook
} from "../helpers/availability/availability";
import { useTranslation } from "react-i18next";

export const useAvailability = () => {
  const { t } = useTranslation();
  const mountTimeRef = useRef(Date.now());
  const lastRecordedKeyRef = useRef<string | null>(null);
  const {
    sessionData,
    clientId,
    host,
    meetingLink,
    providers,
    link,
    actions,
    ui,
    user
  } = useSchedulerStore();

  const fetchAvailability = async () => {
    if (
      !sessionData?.selectedTimezone ||
      !clientId ||
      !host ||
      !meetingLink ||
      !providers
    )
      return;

    actions.setLoadingAvailability(true);

    try {
      const requestSessionStartedAt =
        sessionData.requestSessionStartedAt ?? mountTimeRef.current;
      const actionType = sessionData?.isRescheduleFlow
        ? "reschedule"
        : "schedule";
      const s = sessionData?.prevSelectedSlot?.[0];
      const prevSlotKey = s ? `${s.day}-${s.hour}-${s.minute}` : "";
      const recordingKey = `${meetingLink.type}:${actionType}:${requestSessionStartedAt}:${prevSlotKey}`;
      const skipRecordingSession = lastRecordedKeyRef.current === recordingKey;
      if (!skipRecordingSession) {
        lastRecordedKeyRef.current = recordingKey;
      }

      if (meetingLink.type === "rooster_links") {
        await loadAvailabilityForRoosterLink({
          link,
          clientId,
          host,
          sessionData,
          meetingLink,
          actions,
          providers,
          ui,
          user,
          t,
          mountTime: requestSessionStartedAt,
          skipRecordingSession
        });
      }

      if (meetingLink.type === "rooster" && meetingLink.mode === "autobook") {
        await loadAvailabilityForAutobook({
          link,
          clientId,
          host,
          sessionData,
          meetingLink,
          actions,
          providers,
          ui,
          t,
          mountTime: requestSessionStartedAt,
          skipRecordingSession
        });
      }
    } finally {
      actions.setLoadingAvailability(false);
    }
  };

  return { fetchAvailability };
};
